
import { Box, Typography } from '@mui/material';
import { IOptimizationJob } from 'services/routeOptimizationService';
import { format, isToday, isYesterday } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface DepotSummaryProps {
  jobs: IOptimizationJob[];
  isMobile?: boolean;
}

export const DepotSummary = ({ jobs, isMobile = false }: DepotSummaryProps) => {
  const inProgressJobs = jobs.filter(job => job.status === 'otimizando' || job.status === 'reordenando');
  const hasJobInProgress = inProgressJobs.length > 0;

  // Pegar o job mais recente (por data de criação)
  const sortedJobs = [...jobs].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  const lastJob = sortedJobs[0];

  const getStatusText = () => {
    if (hasJobInProgress) {
      const currentJob = inProgressJobs[0];
      return currentJob.status === 'otimizando' ? 'Otimizando' : 'Reordenando';
    }
    return 'Idle';
  };

  const getStatusColor = () => {
    if (hasJobInProgress) return 'warning';
    return 'default';
  };

  const formatLastJobTime = (job: IOptimizationJob) => {
    if (!job) return 'Nunca';

    const jobDate = new Date(job.createdAt);

    if (isToday(jobDate)) {
      return format(jobDate, 'HH:mm', { locale: ptBR });
    } else if (isYesterday(jobDate)) {
      return 'Ontem';
    } else {
      return format(jobDate, 'dd/MM', { locale: ptBR });
    }
  };

  const getLastJobResult = (job: IOptimizationJob) => {
    if (!job) return '';

    switch (job.status) {
      case 'completo':
        return 'Sucesso';
      case 'cancelado':
        return 'Cancelado';
      case 'otimizando':
      case 'reordenando':
        return 'Em andamento';
      default:
        return job.status;
    }
  };

  const getResultColor = (job: IOptimizationJob) => {
    if (!job) return 'default';

    switch (job.status) {
      case 'completo':
        return 'success';
      case 'cancelado':
        return 'error';
      case 'otimizando':
      case 'reordenando':
        return 'warning';
      default:
        return 'default';
    }
  };

  const content = (
    <>
      {lastJob && (
        <Typography variant="body2">
          <b>Último:</b> {formatLastJobTime(lastJob)} ({getLastJobResult(lastJob)})
        </Typography>
      )}
      <Typography variant="body2">
        <b>Total:</b> {jobs.length}
      </Typography>
    </>
  );

  if (isMobile) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          padding: 2,
          backgroundColor: '#f8f9fa',
          borderRadius: 1,
          marginBottom: 2
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      mr={4}
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      gap={{ xs: 1, md: 4 }}
    >
      {content}
    </Box>
  );
};
